import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { useFormikContext } from "formik";
import { FormArrayTextField } from "../../../../partials/content/Forms/FormField";
import Illustration from "../../../../partials/content/Illustration";
import DialogLayout from "../../../../partials/content/DialogLayout";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import ItemUnitsPriceForm from "./ItemUnitsPriceForm";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import _ from "lodash";

function ItemsPriceFormContent({ history, onReloadItemsSellingPrice }) {
  const { reload } = useGlobalData();
  const [openItemUnitsPrice, setOpenItemUnitsPrice] = useState(false);
  const [selectedGroupID, setSelectedGroupID] = useState(0);
  const [selectedItem, setSelectedItem] = useState(0);
  const { values } = useFormikContext();

  useEffect(() => {}, [reload]);

  const itemSellPriceDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <TabView className="tabview" scrollable>
        {values.customerGroup.map((group, index) => (
          <TabPanel header={group.groupName} key={index}>
            {values.itemsPrice[group.ID].length ? (
              <CustomDataTable
                data={values.itemsPrice[group.ID]}
                dataDetailColumns={itemSellPriceDetailColumn}
                onRefreshData={() => {
                  onReloadItemsSellingPrice();
                }}
                columns={[
                  {
                    header: "Item ID",
                    field: "itemID",
                    body: null,
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Item Type",
                    field: "itemTypeName",
                    body: (rowData) => (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.itemTypeName}
                          maxLine="1"
                        />
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                    hidden: true,
                  },
                  {
                    header: "Item Code",
                    field: "itemCode",
                    body: (rowData) => (
                      <React.Fragment>
                        {rowData.itemType > 0 ? (
                          <span>
                            <BootstrapTooltip title={rowData.itemTypeName}>
                              <span className="mr-2">
                                <i
                                  className={
                                    rowData.itemType === 1
                                      ? "fas fa-boxes text-success"
                                      : rowData.itemType === 2
                                      ? "fas fa-tools text-primary"
                                      : rowData.itemType === 3
                                      ? "fas fa-building text-info"
                                      : rowData.itemType === 4
                                      ? "fas fa-boxes text-warning"
                                      : rowData.itemType === 5
                                      ? "fas fa-boxes text-danger"
                                      : null
                                  }
                                ></i>
                              </span>
                            </BootstrapTooltip>
                            <span>
                              <ResponsiveEllipsis
                                text={rowData.itemCode}
                                maxLine="1"
                                displayInline
                              />
                            </span>
                          </span>
                        ) : (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemCode}
                              maxLine="1"
                            />
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Item Name",
                    field: "itemName",
                    body: (rowData) => (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.itemName}
                          maxLine="1"
                        />
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Base Unit",
                    field: "uomName",
                    body: (rowData) => (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.uomName}
                          maxLine="1"
                        />
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Selling Price",
                    field: "price",
                    body: (rowData, option) => {
                      const index = _.findIndex(
                        values.itemsPrice[group.ID],
                        (item) => {
                          return item.itemID === rowData.itemID;
                        }
                      );
                      return (
                        <FormArrayTextField
                          arrayPropName="itemsPrice"
                          arrayPropName2={group.ID}
                          index={index}
                          propName="price"
                          margin="none"
                          value={rowData.price}
                          currencyField
                        />
                      );
                    },
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Actions",
                    body: (rowData) => (
                      <React.Fragment>
                        <BootstrapTooltip title="Alternative Variant Unit Prices">
                          <button
                            type="button"
                            onClick={(e) => {
                              setSelectedGroupID(group.ID);
                              setSelectedItem(rowData);
                              setOpenItemUnitsPrice(true);
                            }}
                            className="btn btn-icon btn-label-info btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-coins"></i>
                          </button>
                        </BootstrapTooltip>
                      </React.Fragment>
                    ),
                    sortable: false,
                  },
                ]}
              />
            ) : (
              <React.Fragment>
                <Illustration
                  imageSource="INVIFO Sales.png"
                  description="Hooray! You're ready to manage your product Selling Price!"
                  guidance="Hint: manage your products inventory first before setup the Selling Price"
                  descriptionLeftIcon="fas fa-info-circle kt-font-success"
                  size="md"
                ></Illustration>
                <div className="text-center py-3">
                  <button
                    type="button"
                    className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                    onClick={() => {
                      history.push("/inventory/items");
                    }}
                  >
                    <i className="fas fa-map-marker-alt"></i>
                    Go To Item Inventory
                  </button>
                </div>
              </React.Fragment>
            )}
          </TabPanel>
        ))}
      </TabView>
      <DialogLayout
        open={openItemUnitsPrice}
        title={`Item Alternative Variant Unit Prices Form - ${selectedItem.itemCode} ${selectedItem.itemName}`}
        onCloseDialog={() => {
          setOpenItemUnitsPrice(false);
        }}
        maxWIdth="md"
      >
        <ItemUnitsPriceForm
          customerGroupID={selectedGroupID}
          itemID={selectedItem.itemID}
          onConfirmSave={() => {
            setOpenItemUnitsPrice(false);
          }}
          onCloseDialog={() => {
            setOpenItemUnitsPrice(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
}

export default ItemsPriceFormContent;
